import { PagePredictionProperties, PageTypes } from '@shared/types';
export function isPageDeliveryRecord(page) {
    return page.predictions[PagePredictionProperties.type] === PageTypes.delivery;
}
